// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"ModalWindow_modal_wrapper__UXUad","modal_title":"ModalWindow_modal_title__4c3G5","modal_text":"ModalWindow_modal_text__fWbG3"};